import styled from 'styled-components'
import { IconFont } from '@/components'

export const Container = styled.div`
  /* padding: 0 16px; */
  background: #fff;
  border-radius: 8px;
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 30px;
    margin-top: 14px;
    margin-left: 16px;
  }

  // 标题下划线样式
  .ant-sign-title {
    position: relative;
    padding-bottom: 12px;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100px;
      height: 2px;
      background: linear-gradient(90deg, #2b5adc 0%, #22b9e7 100%);
    }
  }

  .container {
    height: calc(100% - 208px);
  }
  .loading-container {
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .template-list {
    background: #f7f8f9;
    border-radius: 8px;
    padding: 16px;
  }
  .template-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
  }
  .template-item {
    background: white;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 1px solid transparent;
    transition: all 0.3s;

    &:hover {
      border-color: #1890ff;
    }

    &.selected {
      border-color: #1890ff;
      background: #e6f7ff;
    }
  }
  .template-content {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .template-icon {
    margin-right: 16px;
  }
  .template-info {
    flex: 1;
  }
  .template-name {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 4px;
  }
  .template-desc {
    font-size: 12px;
    color: #666;
  }
  .template-detail {
    margin-left: 16px;
    color: #1890ff;
    font-size: 16px;
    cursor: pointer;

    &:hover {
      color: #40a9ff;
    }
  }
  .template-detail-content {
    padding: 16px;

    .detail-item {
      margin-bottom: 16px;
      display: flex;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .detail-label {
      width: 100px;
      color: #666;
      flex-shrink: 0;
    }

    .detail-value {
      color: #333;
    }
  }

  .verify-config {
    background: #f7f8f9;
    border-radius: 8px;
    padding: 16px;
    margin-top: 16px;
    margin-left: 120px;

    .config-title {
      color: #666;
      margin-bottom: 16px;
    }

    .config-form {
      .ant-form-item {
        margin-bottom: 24px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .flex-row {
    display: flex;
    align-items: center;
    gap: 6px;

    .label {
      width: 100px;
      color: #666;
    }
  }

  .device-list {
    margin-top: 16px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;

    .device-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .device-id {
        margin-left: 8px;
        color: #666;
      }

      .status-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #52c41a;
        margin-left: auto;
      }
    }
  }

  .steps-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
    .steps {
      width: 560px;
      height: 76px;
      background: rgba(66, 56, 201, 0.04);
      border: 1px dashed #e5e6eb;
      border-radius: 8px;
      position: relative;
      .step-wrapper-container {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .step-wrapper {
          display: flex;
          align-items: center;
          gap: 12px;
        }
      }

      .step-number {
        font-size: 20px;
        font-weight: 600;
        color: #c9cdd4;
        font-family: DINAlternate-Bold, DINAlternate;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 88;
        width: 32px;
        height: 32px;

        &.active {
          background: linear-gradient(90deg, #2b5adc 0%, #22b9e7 100%);
          -webkit-background-clip: text;
          color: transparent;
        }
      }
      .number-1 {
        left: 65px;
        top: -12px;
      }
      .number-2 {
        left: 323px;
        top: -12px;
      }

      .step-content {
        display: flex;
        align-items: center;
        color: #999;

        &.active {
          color: #333;
        }

        .step-icon {
          width: 32px;
          height: 32px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;

          .anticon {
            color: #fff;
            font-size: 16px;
          }
        }

        .step-text {
          font-size: 14px;
        }
      }

      .step-arrow {
        margin: 0 40px;
        color: #d9d9d9;
        font-size: 16px;
      }
    }
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding-top: 12px;
    border-top: 1px solid #d5d9dd;
    padding-bottom: 12px;
    padding-right: 16px;
  }
`
export const ConfigContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  .section {
    margin-bottom: 24px;
    padding: 0 16px;
    .section-title {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      position: relative;
      &::after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 88px;
        height: 6px;
        background: linear-gradient(90deg, #2090a8 0%, #4238c9 100%);
        border-radius: 0px 86px 0px 100px;
        margin-top: 8px;
      }
      .section-bar {
        content: '';
        display: block;
        width: 100%;
        height: 4px;
        background: #ebeaf9;
        margin-top: 10px;
      }
    }

    .form-content {
      margin-top: 16px;
      .custom-label {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .form-item {
        margin-left: 35px;
      }
      .form-item.required {
        margin-left: 34px;
      }
      .auth-form-item {
        .ant-form-item-label {
          flex: 0 0 50px !important;
        }
      }
      .execute-config {
        border-radius: 8px;
        .flex-row {
          margin-left: 115px;
        }
        .execute-template-latest-case label {
          width: 70px;
          line-height: 20px;
          height: 40px;
        }
        .execute-template-latest-case {
          .ant-form-item-label {
            flex: 0 0 70px;
            white-space: normal;
            text-align: left;
            margin-right: 10px;
          }
          .ant-row {
            align-items: center;
          }
          .ant-form-item-control-input-content {
            display: flex;
            align-items: center;
            .ant-switch {
              margin-right: 5px;
            }
          }
        }
      }
      .verify-config {
        .config-title-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .nat-switch-box {
            label {
              color: #86909c;
            }
          }
        }
        .flex-row {
          display: flex;
          align-items: center;
          gap: 0;
          width: 100%;

          .label {
            width: 100px;
            color: #666;
            margin-left: 30px;
            white-space: nowrap;
            flex-shrink: 0;
          }

          .ant-form-item {
            flex: 1;
            margin-bottom: 0;
          }

          .ant-btn-link {
            margin-left: auto;
            flex-shrink: 0;
          }
        }
        .attack-subject-form-item,
        .snat-form-item,
        .attack-node-form-item {
          .ant-form-item-explain-error {
            margin-left: 125px;
          }
          .ant-form-item-label {
            white-space: nowrap;
            min-width: 100px;
            flex: 0 0 100px;
          }
        }
        .attack-subject-form-item {
          .ant-select-in-form-item {
            width: 300px;
          }
        }
        .security-device-form-item {
          label {
            margin-right: 12px;
          }
          .ant-select-in-form-item {
            width: 410px;
          }
          .ant-form-item-explain-error {
            margin-left: 135px;
          }
          .ant-cascader-menus .ant-cascader-menu:first-child .ant-cascader-checkbox {
            display: none !important;
          }
          .ant-cascader-menus .ant-cascader-menu:nth-child(2) .ant-cascader-checkbox {
            display: none !important;
          }
          .ant-form-item-label {
            white-space: nowrap;
            min-width: 120px;
            flex: 0 0 120px;
          }
        }
        .target-subject-form-item {
          .ant-select-in-form-item {
            width: 300px;
          }
          .ant-cascader {
            width: 300px;
          }
          .ant-form-item-explain-error {
            margin-left: 125px;
          }
          .ant-form-item-label {
            white-space: nowrap;
            min-width: 100px;
            flex: 0 0 100px;
          }
        }
      }
      .radio-box {
        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
          border-color: #d9d9d9;
          color: #4238c9;
          background: #e9e8f9;
        }
        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
          background: #d9d9d9;
        }
        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
          box-shadow: none;
        }
      }
      .encoding-type-form-item {
        margin-left: 24px;
      }
    }

    .ant-form-item-label {
      font-weight: 500;
      white-space: nowrap;
      text-align: left;
    }
  }
`
export const TemplateContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
  min-width: 1180px;
  padding: 0 16px;
  .case-table {
    .detail-btn {
      color: #4238c9;
      cursor: pointer;
      &:hover {
        color: #6a5ed6;
      }
    }
  }

  .ant-table-measure-row {
    display: none;
  }
  .ant-table-column-sorters {
    justify-content: flex-start;
    .ant-table-column-sorter {
      padding-top: 4px;
      margin-left: 5px;
    }
    .ant-table-column-title {
      flex: none;
    }
  }

  .ant-table-filter-column {
    justify-content: flex-start;
    .ant-table-column-title {
      flex: none;
    }
  }

  .ant-form {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .template-section {
    width: 50%;
  }
  .case-section {
    width: 50%;
  }
  .template-section,
  .case-section {
    height: 100%;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e5e6eb;
    padding: 0;
    min-width: 650px; // 防止flex子项溢出
    .ant-pagination {
      margin-bottom: 20px;
      margin-right: 16px;
    }
    .ant-table {
      padding: 0 16px;
    }
  }
  .filter-form-container {
    margin-bottom: 16px;
    .filter-search {
      width: 100%;
      padding: 0 16px;
      .filter-form {
        width: 100%;
      }
    }
  }

  .section-title {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    padding: 0 16px;
  }
  .template-title {
    margin: 10px 0 18px;
  }

  .header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
    .save-template-btn {
      height: 30px;
      line-height: 25px;
      margin-right: 16px;
      margin-left: 8px;
    }
  }

  .search-area {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 12px;
    flex-wrap: wrap;
    padding: 0 16px;
    .ant-checkbox-wrapper {
      margin-right: 16px;
    }
  }

  .ant-table-wrapper {
    .ant-table-thead {
      > tr > th {
        background: #f7f8fa;
        height: 48px;
        padding: 12px 8px;
        &::before {
          display: none;
        }
      }
    }
    .ant-table-tbody {
      > tr > td {
        height: 48px;
        padding: 12px 8px;
      }
    }
  }

  .ant-tag {
    border-radius: 4px;
    padding: 0 8px;
    margin-right: 0;
  }

  // 表格内容样式优化
  .ant-table {
    font-size: 14px;
    line-height: 22px;

    .ant-table-cell {
      padding: 12px 8px;
    }
  }

  // 分页样式优化
  .ant-pagination {
    margin: 16px 0 0;
  }

  // 标签样式
  .system-tag {
    background: #f2f3f5;
    border-radius: 2px;
    padding: 2px 8px;
    font-size: 12px;
    color: #86909c;
  }

  // 开关样式
  .leak-low {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #e1ebfe;
    color: #6f9fff;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }

  .leak-center {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #ffedce;
    color: #ffa709;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }

  .leak-high {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #ffe1e1;
    color: #ff4141;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }

  .leak-severity {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #f5d9d9;
    color: #b70000;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }
  .resource-level-junior {
    display: inline-block;
    background: #6f9fff;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    width: 36px;
    height: 16px;
    line-height: 16px;
    text-align: center;
  }
  .resource-level-middle {
    display: inline-block;
    background: #ffa709;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    width: 36px;
    height: 16px;
    line-height: 16px;
    text-align: center;
  }
  .resource-level-senior {
    display: inline-block;
    background: #f44f4f;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    width: 36px;
    height: 16px;
    line-height: 16px;
    text-align: center;
  }
`
export const FilterIcon = styled(IconFont)<{ $filtered?: boolean }>`
  font-size: 14px;
  color: ${props => (props.$filtered ? '#4238C9' : '#999')};
  cursor: pointer;
  transition: color 0.3s;
  &:hover {
    color: #4238c9;
  }
`
